import {I18n} from '@volkswagen-onehub/car-technical-details-schemas';
import {
  styled,
  TextTag,
  TokenTextAppearance,
  Text,
} from '@volkswagen-onehub/components-core';
import {Alert} from '@volkswagen-onehub/icons-core';
import * as React from 'react';
import {useTranslate} from '../utils/translate';

const StyledNoDataWrapper = styled.div`
  display: grid;
  gap: ${(props) => props.theme.size.static150};
  justify-self: center;
  width: ${(props) => `clamp(15rem, ${props.theme.size.grid012}, 30rem)`};

  & button {
    justify-self: center;
    align-self: center;
  }
`;

export const NoDataPage = (): JSX.Element => {
  const translateFn = useTranslate();

  let headline = translateFn('nodata.headline');
  let copy = translateFn('nodata.copy');
  if (!headline && !copy) {
    const i18n = new I18n();
    headline = i18n['nodata.headline']!;
    copy = i18n['nodata.copy']!;
  }

  return (
    <StyledNoDataWrapper>
      <Alert variant={'large'} />
      <Text tag={TextTag.h1} appearance={TokenTextAppearance.headline400} bold>
        {headline}
      </Text>
      <Text tag={TextTag.p}>{copy}</Text>
    </StyledNoDataWrapper>
  );
};
